class Utils {
    validateURL(textval) {
        const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
        return urlregex.test(textval);
    }
    durationProcent(start, current, end) {
        if (start && current && end) {
            let timeStart = this.HMStoSec1(start + ":00");
            let timeEnd = this.HMStoSec1(end + ":00");
            let timeCurrent = this.HMStoSec1(current);
            let do_konca_min = timeCurrent - timeStart;
            let trajanje_min = timeEnd - timeStart;
            let percent = (trajanje_min - do_konca_min) / trajanje_min;
            if (isNaN(percent)) {
                return 0;
            }
            else {
                return 100 - (percent * 100);
            }
        }
    }
    HMStoSec1(T) {
        // h:m:s
        let A = T.split(/\D+/);
        return (A[0] * 60 + +A[1]) * 60 + +A[2];
    }
    convert(time) {
        if (time) {
            let tempTime = time.split(':');
            return tempTime[0] + ':' + tempTime[1];
        }
    }
    calculateBeginning(data) {
        let today = new Date();
        today.toLocaleString("sl-SL", { timeZone: "Europe/Ljubljana" });
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const startTime = this.HMStoSec1(data.start);
        const currentTime = this.HMStoSec1(time);
        return (currentTime - startTime);
        // return "-" + (currentTime - startTime).toString()
    }
}
export const utils = new Utils();
